import { useState } from 'react';
import { Link } from 'react-router-dom';
import { authAPI } from '../utils/api';
import toast from 'react-hot-toast';
import './Auth.css';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) return toast.error('Email enter karo');
    setLoading(true);
    try {
      await authAPI.forgotPassword(email);
      setSent(true);
      toast.success('Reset link bhej diya! Email check karo.');
    } catch (err) {
      toast.error(err.response?.data?.message || 'Error aaya');
    }
    setLoading(false);
  };

  return (
    <div className="auth-page page">
      <div className="container">
        <div className="auth-card card">
          <div className="auth-header">
            <h2>🔑 Password Reset</h2>
            <p>Email enter karo — reset link bhejenge</p>
          </div>
          {sent ? (
            <div className="success-msg">
              <div style={{fontSize:'3rem', marginBottom:'16px'}}>📧</div>
              <h3>Email bhej diya!</h3>
              <p>Inbox check karo — reset link wahan milega.</p>
              <Link to="/login" className="btn btn-primary" style={{marginTop:'20px',display:'inline-block'}}>Login pe wapas jao</Link>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="auth-form">
              <div className="form-group">
                <label>Email</label>
                <input type="email" value={email} onChange={e => setEmail(e.target.value)}
                  placeholder="apni@email.com" className="form-input" required />
              </div>
              <button type="submit" className="btn btn-primary btn-full" disabled={loading}>
                {loading ? 'Bhej rahe hain...' : 'Reset Link Bhejo'}
              </button>
              <p className="auth-link"><Link to="/login">← Login pe wapas jao</Link></p>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
